import { useNavigate } from "react-router-dom";
import { Archive } from "lucide-react";
import { usePresentationDetail, useArchivePresentation } from "../../../lib/presentationQueries";

const JUMP_AREAS = [
  ["goal-audience", "Goal & Audience"], ["idea-bank", "Idea Bank"], ["structure", "Structure"],
  ["message", "Sections & Message"], ["delivery", "Delivery Layers"], ["versions", "Version History"],
];

export default function OverviewArea({ workspaceId, presId }) {
  const navigate = useNavigate();
  const { data } = usePresentationDetail(workspaceId, presId);
  const archivePresentation = useArchivePresentation(workspaceId);
  if (!data) return null;
  const { project, context, completion_percent, idea_card_count, section_count, beat_count } = data;

  return (
    <div className="max-w-2xl" data-testid="presentation-overview-area">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif text-xl text-ink">Overview</h2>
        <button
          onClick={() => { archivePresentation.mutate(project.pres_id); navigate(`/rehearsal-room/w/${workspaceId}/presentation`); }}
          className="inline-flex items-center gap-1.5 text-xs text-ink-soft hover:text-terracotta"
          data-testid="presentation-overview-archive"
        >
          <Archive size={14} /> Archive
        </button>
      </div>
      <div className="border border-ink/15 bg-white/50 rounded-lg p-5 mb-5" data-testid="presentation-overview-completion">
        <p className="text-sm text-ink-soft mb-1">Completion</p>
        <p className="text-2xl font-serif text-ink mb-1">{completion_percent}%</p>
        <p className="text-xs text-ink-soft">
          {beat_count} beat{beat_count === 1 ? "" : "s"} across {section_count} section{section_count === 1 ? "" : "s"} · {idea_card_count} idea{idea_card_count === 1 ? "" : "s"} in the bank
        </p>
      </div>
      {context?.goal_text && (
        <div className="mb-5" data-testid="presentation-overview-goal">
          <p className="text-sm uppercase tracking-wide text-ink-soft mb-1">Goal</p>
          <p className="text-ink">{context.goal_text}</p>
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-2">
        {JUMP_AREAS.map(([key, label]) => (
          <button
            key={key} onClick={() => navigate(`/rehearsal-room/w/${workspaceId}/presentation/${presId}/${key}`)}
            className="text-left border border-ink/15 bg-white/40 rounded-lg px-4 py-3 text-sm text-ink hover:border-terracotta hover:text-terracotta transition-colors"
            data-testid={`presentation-overview-jump-${key}`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
